const getExpertsRating = (rating = 0) => (
  Math.min(Math.floor(rating * 5 + 1), 5)
);

// eslint-disable-next-line import/prefer-default-export
export { getExpertsRating };
